import { Role } from '../role';
import { RestApiResponse } from '../../common/rest-api.response';

export class RoleGetResponse extends RestApiResponse {
    public role: Role;

    constructor(data?: Partial<RoleGetResponse>) {
        super(data);
        this.role = data && data.role;
    }
}
